import { styled } from "@100mslive/react-ui";

export const Image = styled("img", {
  width: "100%",
  height: "auto",
  r: "$3",
});
